module.exports = __webpack_public_path__ + "img/slack-community.ef623acf.svg";